import { call, put } from 'typed-redux-saga/macro';

import type { GetActionByType } from 'Lib/reduxType';

import { setDeeplinkNavigationInfo } from 'Store/user/actions';

import { VERIFY_NAVIGATE_ROUTE } from '../constants';
import { handleInitialRouting } from './common';

export function* verifyNavigateDeeplinkRouteSaga(
  action: GetActionByType<typeof VERIFY_NAVIGATE_ROUTE>
) {
  yield* put(setDeeplinkNavigationInfo(action.payload));
  yield* call(handleInitialRouting);
}
